import React, { Component } from "react";
import moment from "moment";
import { Drawer, Table, Tag, Icon } from "antd"; // Added Tag and Icon
import Request from "../../request";
import common from "../../containers/common.less";
import { connect } from "react-redux";
import LatestFollowUp from "../../components/_utils/latestFollowup";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

const link = {
    "Front Desk": '/desk/update-counselling',
    "Registration Desk": "/registration/fees",
    "Application Desk": "/desk/allApplication-desk/update",
    "Visa Desk": "/desk/getVisa",
    "Claim Desk": "/desk/getClaim"
}

class InvoiceListDrawer extends Component {
    state = {
        visible: true,
        arr: [],
        loading: false
    };

    componentDidMount() {
        this.loadDashboardStudentList();
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 400);
    };

    loadDashboardStudentList = async () => {
        this.setState({ loading: true });
        const { arr } = this.props.param;
        this.setState({ arr, loading: false });
    };

    // ... inside your DashboardStudentList class

    render() {
        const { arr, loading } = this.state;
        const { title, count, bgColorClass, icon } = this.props.param;

        // inside your DashboardStudentList class -> column array

        const column = [
            {
                title: "Student Details",
                key: "student",
                width: "15%",
                render: (text, record) => {
                    const redirectPath = link[record.atLevel] || "#";
                    return (
                        <div className="student-info-wrapper">
                            <div style={{ fontWeight: 700, color: "#1a3353", fontSize: '15px' }}>
                                <a
                                    href={redirectPath + '?id=' + record._id}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {record.studentName}
                                </a>
                            </div>

                            <Tag style={{ width: 'fit-content', fontSize: '10px', borderRadius: '4px' }}>
                                ID: {record.vid}
                            </Tag>
                        </div>
                    );
                }
            },
            {
                title: 'DOB',
                dataIndex: 'dateOfBirth',
                key: 'dateOfBirth',
                width: '12%',
                render: (text, record) => {
                    var dob = record.dateOfBirth ? moment(record.dateOfBirth).format(dateFormat) : '-';
                    return (
                        <div style={{ paddingTop: '4px' }}>
                            <span style={{ fontWeight: 500, color: '#434343' }}>{dob || '-'}</span>
                        </div>
                    )
                }
            },
            {
                title: "Invoice Number",
                dataIndex: "invoiceNumber",
                key: "invoiceNumber",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Inv. Generation Date",
                dataIndex: "invoiceGenerationDate",
                key: "invoiceGenerationDate",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{moment(text).format(dateFormat)}</span>
                    </div>
                )
            },
            {
                title: "Invoice Type",
                dataIndex: "invoiceType",
                key: "invoiceType",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Inv. Term",
                dataIndex: "termNumber",
                key: "termNumber",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text}-Term</span>
                    </div>
                )
            },
            {
                title: "Country",
                dataIndex: "countryName",
                key: "countryName",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
            {
                title: "Invoice Amount",
                dataIndex: "invoiceAmount",
                key: "invoiceAmount",
                width: "12%",
                render: (text, record) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{record.invoiceAmount}({record.currency})</span>
                    </div>
                )
            },
            {
                title: "Invoice Status",
                dataIndex: "status",
                key: "status",
                width: "12%",
                render: (text) => (
                    <div style={{ paddingTop: '4px' }}>
                        <span style={{ fontWeight: 500, color: '#434343' }}>{text || '-'}</span>
                    </div>
                )
            },
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            {/* Render the dynamic icon here. If it's a React component, it will render. */}
                            <span style={{ marginRight: 12, display: 'flex', fontSize: '20px' }}>
                                {icon ? icon : <Icon type="profile" />}
                            </span>
                            {title}
                        </span>
                        <Tag className="count-tag">{count} TOTAL</Tag>
                    </div>
                }
                placement="right"
                onClose={this.onClose}
                visible={this.state.visible}
                width={1250}
                className={`dynamic-drawer ${bgColorClass}`}
            >
                <Table
                    dataSource={arr}
                    columns={column}
                    loading={loading}
                    rowKey={(record, index) => index}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"],
                    }}
                    scroll={{ y: 400 }}
                />

            </Drawer>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    currentUser: global.currentUser,
});

export default connect(mapStateToProps, null)(InvoiceListDrawer);